
document.addEventListener('DOMContentLoaded', async () => {
  const section = document.querySelector(
    'product-recommendations[data-matching-set]'
  );

  if (!section) return;

  const setTag = section.dataset.matchingSet;

  if (!setTag) return;

  const searchQuery = `tag:"${setTag}"`;
  const searchUrl = `/search?type=product&q=${encodeURIComponent(searchQuery)}`;

  try {
    const response = await fetch(searchUrl);

    if (!response.ok) {
      throw new Error(`Search failed: ${response.status}`);
    }

    const html = await response.text();
    const parser = new DOMParser();
    const searchPage = parser.parseFromString(html, 'text/html');

    const products = searchPage.querySelectorAll(
      '.product-card'
    );

const recommendationList = section.querySelector('product-list');

const currentProductPath = window.location.pathname;

const matchingProducts = Array.from(products).filter((card) => {
  const link = card.querySelector('a[href*="/products/"]');

  if (!link) return false;

  const productPath = new URL(link.href).pathname;

  return productPath !== currentProductPath;
});

const uniqueMatchingProducts = Array.from(
  new Map(
    matchingProducts.map((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      return [new URL(link.href).pathname, card];
    })
  ).values()
);

if (recommendationList && uniqueMatchingProducts.length > 0) {

const maxProducts = 4;


  const getProductPath = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    return link ? new URL(link.href).pathname : null;
  };

  const existingCards = Array.from(
    recommendationList.querySelectorAll(':scope > product-card')
  );

  const selectedCards = [];
  const usedPaths = new Set([currentProductPath]);

  // Priority 1: Matching-set products
  for (const card of uniqueMatchingProducts) {
    const path = getProductPath(card);

    if (!path || usedPaths.has(path)) continue;

    selectedCards.push(card);
    usedPaths.add(path);

    if (selectedCards.length >= maxProducts) break;
  }

  // Priority 2: Existing category and designer recommendations
  for (const card of existingCards) {
    if (selectedCards.length >= maxProducts) break;

    const path = getProductPath(card);

    if (!path || usedPaths.has(path)) continue;

    selectedCards.push(card);
    usedPaths.add(path);
  }

  
if (selectedCards.length > 0) {
  recommendationList.replaceChildren(...selectedCards);

  // Test image visibility for dynamically inserted cards
  selectedCards.forEach((card) => {
    card.style.opacity = '1';
    card.style.transform = 'none';

    card.querySelectorAll('img').forEach((img) => {
      img.loading = 'eager';
    });
  });
}

}
} catch (error) {
    console.error('Matching set search failed:', error);
  }
});
